/* ============================================
   LØVENSTORE — Quick-Add AJAX Cart + Size Selection
   Minimal JS for the inline size quick-add on product cards
   ============================================ */

(function() {
  'use strict';

  // Size button click — select variant
  document.addEventListener('click', function(e) {
    var sizeBtn = e.target.closest('.loven-size-btn');
    if (!sizeBtn || sizeBtn.classList.contains('sold-out')) return;

    e.preventDefault();
    e.stopPropagation();

    // Deselect siblings, select this one
    var list = sizeBtn.closest('.loven-quick-add__list');
    if (list) {
      list.querySelectorAll('.loven-size-btn').forEach(function(btn) {
        btn.classList.remove('selected');
      });
    }
    sizeBtn.classList.add('selected');
  });

  // "Toevoegen" button click — add to cart via AJAX
  document.addEventListener('click', function(e) {
    var addBtn = e.target.closest('.loven-quick-add__btn');
    if (!addBtn) return;

    e.preventDefault();
    e.stopPropagation();

    // Determine variant ID
    var variantId = addBtn.getAttribute('data-variant-id');
    if (!variantId) {
      // Look for selected size button in the same quick-add container
      var container = addBtn.closest('.loven-quick-add');
      if (container) {
        var selectedSize = container.querySelector('.loven-size-btn.selected');
        if (selectedSize) {
          variantId = selectedSize.getAttribute('data-variant-id');
        } else {
          // Auto-select first available size
          var firstAvailable = container.querySelector('.loven-size-btn:not(.sold-out)');
          if (firstAvailable) {
            firstAvailable.classList.add('selected');
            variantId = firstAvailable.getAttribute('data-variant-id');
          }
        }
      }
    }

    if (!variantId) return;

    // Prevent double-clicks
    if (addBtn.classList.contains('adding')) return;
    addBtn.classList.add('adding');

    // Save original content
    var originalHTML = addBtn.innerHTML;

    // AJAX add to cart
    fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1
      })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    })
    .then(function() {
      // Success animation
      addBtn.innerHTML = '<svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M4.5 12.75l6 6 9-13.5"/></svg> Toegevoegd!';
      addBtn.classList.add('added');

      // Update cart count in header (Dawn's cart-count-bubble)
      updateCartCount();

      // Revert after 1.5s
      setTimeout(function() {
        addBtn.innerHTML = originalHTML;
        addBtn.classList.remove('added');
        addBtn.classList.remove('adding');
      }, 1500);
    })
    .catch(function() {
      addBtn.innerHTML = 'Fout — probeer opnieuw';
      setTimeout(function() {
        addBtn.innerHTML = originalHTML;
        addBtn.classList.remove('adding');
      }, 1500);
    });
  });

  // Nav arrow clicks for scrollable sizes
  document.addEventListener('click', function(e) {
    var nav = e.target.closest('.loven-quick-add__nav');
    if (!nav) return;

    e.preventDefault();
    e.stopPropagation();

    var list = nav.closest('.loven-quick-add__sizes').querySelector('.loven-quick-add__list');
    if (!list) return;

    var scrollAmount = 120;
    if (nav.classList.contains('loven-quick-add__nav--prev')) {
      list.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      list.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  });

  // Update Dawn's cart count bubble
  function updateCartCount() {
    fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var bubbles = document.querySelectorAll('.cart-count-bubble');
      bubbles.forEach(function(bubble) {
        var countEl = bubble.querySelector('[aria-hidden="true"]');
        if (countEl) countEl.textContent = cart.item_count;
        var srEl = bubble.querySelector('.visually-hidden');
        if (srEl) srEl.textContent = cart.item_count + ' items';
        bubble.style.display = cart.item_count > 0 ? '' : 'none';
      });

      // Also dispatch Dawn's cart update event if available
      if (typeof publish === 'function') {
        publish('cart:refresh');
      }

      // Trigger Dawn's cart drawer refresh
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        fetch('/cart?section_id=cart-drawer')
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newDrawer = doc.querySelector('cart-drawer');
            if (newDrawer && cartDrawer) {
              cartDrawer.innerHTML = newDrawer.innerHTML;
            }
          });
      }
    })
    .catch(function() {});
  }

  // Prevent card link navigation when interacting with quick-add
  document.addEventListener('click', function(e) {
    if (e.target.closest('.loven-quick-add')) {
      // Already handled above, but ensure no propagation to card link
      var cardLink = e.target.closest('.card-wrapper');
      if (cardLink) {
        var link = cardLink.querySelector('a.full-unstyled-link');
        if (link && e.target !== link && !e.target.closest('a')) {
          // Don't navigate
        }
      }
    }
  });
})();
